export default __webpack_public_path__ + "static/media/book.0427074c.png";